/* eslint-disable import/prefer-default-export */
import { configureSegment } from '@chegg-wt/core/utils/routes'
import { getActualStyleId } from '@chegg-wt/core/utils/styles'
import { getSegmentFn, getIsExactFn } from '@chegg-wt/core/utils/url'
import { GetFromQuery, IsExact } from '@chegg-wt/core/types/core'

export const matchSourceSegment = configureSegment(':source-citation')

export const sourceSegmentRoutes = [
  '/[style]/[source]/search',
  '/[style]/[source]/eval',
  '/[style]/[source]/new',
  '/[style]/[source]/custom',
  '/[style]/[source]/edit',
]

export const getSourceFromQuery: GetFromQuery = getSegmentFn({
  segmentRoutes: sourceSegmentRoutes,
  matchSegment: matchSourceSegment,
  paramName: 'source',
})

export const isSourceExact: IsExact = getIsExactFn({
  segmentRoutes: sourceSegmentRoutes,
  matchSegment: matchSourceSegment,
})

export const matchStyleSegment = configureSegment(':style-format')

export const styleSegmentRoutes = [
  '/[style]/[source]/new',
  '/[style]/[source]/custom',
  '/[style]/[source]/edit',
]

export const getStyleFromQuery: GetFromQuery = (router, query, wrapByAlias = true) => {
  const matchedValue = getSegmentFn({
    segmentRoutes: styleSegmentRoutes,
    matchSegment: matchStyleSegment,
    paramName: 'style',
  })(router, query)

  return wrapByAlias ? getActualStyleId(matchedValue) : matchedValue
}

export const isStyleExact: IsExact = getIsExactFn({
  segmentRoutes: styleSegmentRoutes,
  matchSegment: matchStyleSegment,
})
